import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Iframe recursion guard — prevent infinite embed loops (Sentinel Directive)
try {
  if (window.self !== window.top && window.location.hostname === window.parent.location.hostname) {
    document.body.innerHTML = '<p>Recursion blocked</p>';
    throw new Error('Iframe recursion detected');
  }
} catch (e) {
  if (e.message === 'Iframe recursion detected') throw e;
  // Cross-origin parent access throws — different hostname, safe to continue.
}

// Museum Standard: index.html ships a hand-written semantic shell inside #root
// for crawlers / JS-disabled agents. It is NOT a react-snap snapshot, so we
// must REPLACE it (createRoot), never hydrate it — hydration would always
// mismatch and throw recoverable errors on every page.
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
